<template>
  <a class="quiz-form--next-link" :class="{'visible': isShow}" @click="onClickNextSlide">
    <span class="next-button">{{ isLastSlide ? $t('finishButton') : $t('nextButton') }}</span>
    <i v-if="!isLastSlide" class="fas fa-angle-double-right animated-arrow" />
  </a>
</template>

<script>
import EventBus from '@/eventBus'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    ...mapState({
      isLastSlide: (state) => {
        return state.slide.id === state.presentation.lastSlide
      },
    }),
  },
  mounted() {
    setTimeout(() => {
      this.isShow = true
    }, 1e3)
  },
  methods: {
    onClickNextSlide() {
      if (!this.isLastSlide) {
        EventBus.$emit('skipSlide')
      } else {
        this.$store.dispatch('updateSlide', {
          isEndSlide: true,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$icon-margin-left: 4px;
@keyframes move-right {
    50% {
        transform: translateX(calc(#{$icon-margin-left} + 4px));
    }
    100% {
        transform: translateX(#{$icon-margin-left});
    }
}

.quiz-form--next-link {
    color: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 16px;
    opacity: 0;
    transition: opacity 0.5s ease;
    &.visible {
        opacity: 1
    }
}

.animated-arrow {
    font-size: 14px;
    transform: translateX(#{$icon-margin-left});
    animation: move-right 1s infinite ease;
}

</style>
